import { db } from '@/firebase'
import { doc, getDoc, setDoc, updateDoc, collection, getDocs, onSnapshot, addDoc, deleteDoc, query, where } from 'firebase/firestore'

const COLLECTION_NAME = 'users'

export const userService = {
  async getUser(uid) {
    const userRef = doc(db, COLLECTION_NAME, uid)
    const snap = await getDoc(userRef)
    return snap.exists() ? snap.data() : null
  },

  async createUser(uid, userData) {
    const userRef = doc(db, COLLECTION_NAME, uid)
    await setDoc(userRef, {
      ...userData,
      createdAt: new Date()
    })
  },

  async updateUser(uid, data) {
    const userRef = doc(db, COLLECTION_NAME, uid)
    await updateDoc(userRef, data) // updateDoc is better for partial updates
  },
  
  // Per initial set/overwrite if needed, though usually update is safer
  async setUser(uid, data, options = { merge: true }) {
      const userRef = doc(db, COLLECTION_NAME, uid)
      await setDoc(userRef, data, options)
  },

  listenToUser(uid, onChange) {
    const userRef = doc(db, COLLECTION_NAME, uid)
    return onSnapshot(userRef, (snap) => {
      if (snap.exists()) {
        onChange(snap.data())
      }
    })
  },

  async getAll() {
      // Implement logic to get all users or specific query if needed
      // For now, placeholder or specific query
      const q = query(collection(db, 'users'));
      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  },
  
  async ensureUserExists(user) {
      if (!user) return;
      const userRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userRef);
      if (!userSnap.exists()) {
          await setDoc(userRef, {
              email: user.email,
              username: user.email.split('@')[0],
              avatar: 'character-1'
          });
      }
  },

  async updateUserProfile(userId, data) {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, data);
  },

  async getUserCollection(userId, collectionName) {
      // collectionName: 'blades', 'rachets', 'bits'
      // Optimization: Fetch only items owned by user using array-contains
      const itemsRef = collection(db, collectionName);
      const q = query(itemsRef, where('checkedBy', 'array-contains', userId));
      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => doc.data());
  },

  async getTrophies(uid) {
    const trophiesCol = collection(db, COLLECTION_NAME, uid, 'trophies')
    const snap = await getDocs(trophiesCol)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  },

  // --- TEAMS (New Feature) ---
  async getUserTeams(uid) {
    const teamsCol = collection(db, COLLECTION_NAME, uid, 'teams')
    const snap = await getDocs(teamsCol)
    return snap.docs.map(d => ({ id: d.id, ...d.data() }))
  },

  async saveUserTeam(uid, teamData) {
      if (teamData.id) {
          // Update existing
          const teamRef = doc(db, COLLECTION_NAME, uid, 'teams', teamData.id)
          await updateDoc(teamRef, teamData)
          return teamData.id
      } else {
          // Create new
          const teamsCol = collection(db, COLLECTION_NAME, uid, 'teams')
          const docRef = await addDoc(teamsCol, {
              ...teamData,
              createdAt: new Date()
          })
          return docRef.id
      }
  },

  async deleteUserTeam(uid, teamId) {
      const teamRef = doc(db, COLLECTION_NAME, uid, 'teams', teamId)
      await deleteDoc(teamRef)
  }
}
